<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    :items="typesAg"
    item-value="id"
    :data-testid="dataTestid"
  />
</template>

<script>
import { sousTypeDocument } from "@/filters/typedocument";
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      typesAg: ["EXTRA", "ORDINAIRE", "CONSTITUTIVE"].map(id => ({
        id,
        text: sousTypeDocument(id),
      })),
    };
  },
};
</script>
